// @ts-nocheck
// fetch opportunities
export const GET_APPLIED_OPPORTUNITIES_REQUEST =
  "GET_APPLIED_OPPORTUNITIES_REQUEST";
export const GET_APPLIED_OPPORTUNITIES_SUCCESS =
  "GET_APPLIED_OPPORTUNITIES_SUCCESS";
export const GET_APPLIED_OPPORTUNITIES_FAIL = "GET_APPLIED_OPPORTUNITIES_FAIL";

// get not responded opportunity
export const GET_NOT_RESPONDED_OPPORTUNITIES_REQUEST =
  "GET_NOT_RESPONDED_OPPORTUNITIES_REQUEST";
export const GET_NOT_RESPONDED_OPPORTUNITIES_SUCCESS =
  "GET_NOT_RESPONDED_OPPORTUNITIES_SUCCESS";
export const GET_NOT_RESPONDED_OPPORTUNITIES_FAIL =
  "GET_NOT_RESPONDED_OPPORTUNITIES_FAIL";

// get all opportunity
export const GET_ALL_OPPORTUNITIES_REQUEST = "GET_ALL_OPPORTUNITIES_REQUEST";
export const GET_ALL_OPPORTUNITIES_SUCCESS = "GET_ALL_OPPORTUNITIES_SUCCESS";
export const GET_ALL_OPPORTUNITIES_FAIL = "GET_ALL_OPPORTUNITIES_FAIL";

// apply to opportunity
export const APPLY_OPPORTUNITY_REQUEST = "APPLY_OPPORTUNITY_REQUEST";
export const APPLY_OPPORTUNITY_SUCCESS = "APPLY_OPPORTUNITY_SUCCESS";
export const APPLY_OPPORTUNITY_FAIL = "APPLY_OPPORTUNITY_FAIL";

// decline opportunity
export const DECLINE_OPPORTUNITY_REQUEST = "DECLINE_OPPORTUNITY_REQUEST";
export const DECLINE_OPPORTUNITY_SUCCESS = "DECLINE_OPPORTUNITY_SUCCESS";
export const DECLINE_OPPORTUNITY_FAIL = "DECLINE_OPPORTUNITY_FAIL";

// get reported issue for contractor
export const GET_CONTRACTOR_ISSUES_REQUEST = "GET_CONTRACTOR_ISSUES_REQUEST";
export const GET_CONTRACTOR_ISSUES_SUCCESS = "GET_CONTRACTOR_ISSUES_SUCCESS";
export const GET_CONTRACTOR_ISSUES_FAIL = "GET_CONTRACTOR_ISSUES_FAIL";

// get contractor events
export const GET_CONTRACTOR_EVENTS_REQUEST = "GET_CONTRACTOR_EVENTS_REQUEST";
export const GET_CONTRACTOR_EVENTS_SUCCESS = "GET_CONTRACTOR_EVENTS_SUCCESS";
export const GET_CONTRACTOR_EVENTS_FAIL = "GET_CONTRACTOR_EVENTS_FAIL";

// decline opportunity anyway request
export const DECLINE_OPPORTUNITY_ANYWAY_REQUEST =
  "DECLINE_OPPORTUNITY_ANYWAY_REQUEST";
export const DECLINE_OPPORTUNITY_ANYWAY_SUCCESS =
  "DECLINE_OPPORTUNITY_ANYWAY_SUCCESS";
export const DECLINE_OPPORTUNITY_ANYWAY_FAILURE =
  "DECLINE_OPPORTUNITY_ANYWAY_FAILURE";

// decline opportunity for multiple dates
export const DECLINE_OPPORTUNITY_MULTIPLE_REQUEST =
  "DECLINE_OPPORTUNITY_MULTIPLE_REQUEST";
export const DECLINE_OPPORTUNITY_MULTIPLE_SUCCESS =
  "DECLINE_OPPORTUNITY_MULTIPLE_SUCCESS";
export const DECLINE_OPPORTUNITY_MULTIPLE_FAILURE =
  "DECLINE_OPPORTUNITY_MULTIPLE_FAILURE";

// clear contractor applied list
export const CLEAR_CONTRACTOR_APPLIED_LIST = "CLEAR_CONTRACTOR_APPLIED_LIST";